import { CSSProperties, FC, ReactNode } from 'react';
import { theme, Typography } from 'antd';
const { useToken } = theme;

interface FormLabelProps {
  label: string | ReactNode;
  required?: boolean;
  style?: CSSProperties;
  subLabel?: string;
  size?: 'large' | 'middle' | 'small';
}

const FormLabel: FC<FormLabelProps> = ({
  label,
  required = false,
  style,
  subLabel,
  size = 'middle',
}) => {
  const { token } = useToken();
  return (
    <div
      className={`form-label-wrap ${required ? 'required' : ''}`}
      style={{ ...style, paddingBottom: '4px' }}
    >
      <label className="form-label">
        <Typography.Text
          style={{
            color: token.colorTextHeading,
            fontWeight: 500,
            fontSize:
              size === 'large' ? '16px' : size === 'middle' ? '15px' : '12px',
          }}
        >
          {label}
        </Typography.Text>
      </label>
      {subLabel && (
        <Typography.Text
          style={{
            display: 'block',
            fontSize: size === 'large' ? '13px' : '12px',
            color: token.colorTextSecondary,
          }}
        >
          {subLabel}
        </Typography.Text>
      )}
    </div>
  );
};

export default FormLabel;
